import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import InputType from "common/form/InputType";
import { CourseComponentConfig, courseComponentConfigInput } from "./component/CourseComponentConfig";

// tslint:disable:max-classes-per-file

class TagSet {
	@Field() public id: ID;
	@Field() public name: string;
}

@Entity({many: "tags"})
class Tag {
	@Field() public id: ID;
	@Field() public name: string;
	@Field({entity: TagSet}) public tagSet: TagSet;
}

const tagsSelect = EntityMultiSelect.registered(Tag, {pageSize: 1000}, {getSecondaryLabel: (tag: Tag) => tag.tagSet.name});

@Form({title: "Bundle Entries Config"})
export default class BundleEntriesConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize?: number;

	@Input({type: courseComponentConfigInput, title: "Course Display Settings"})
	public courseConfig?: CourseComponentConfig = new CourseComponentConfig();

	@Input({type: tagsSelect, title: "Filter To Tags"})
	public tags?: ID[];

	@Input({type: InputType.CHECKBOX, title: "Enable Bundle Purchase"})
	public enableBundlePurchase?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Use Credits as Default Payment"})
	public creditsPaymentType?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Price on Products"})
	public showPrice?: boolean;
}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/BundleEntriesConfig.ts